import { getReservedOrderSeatsForShowtime } from './get-reserved-order-seats-for-showtime';
export const getReservedOrderSeatIdsForShowtime = (showtimeId) => {
    return getReservedOrderSeatsForShowtime(showtimeId).map(seat => seat.seatId);
};
